/* eslint-disable */
export const isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ? true : false



// WEBPACK FOOTER //
// ./src/common/js/util.js